import Head from "next/head";
import React from "react";

const SeoFaq: React.FC<{ faq: Record<string, any> }> = ({ faq }) => {
    return (
        <Head>
            <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faq) }} />
        </Head>
    );
};

export default SeoFaq;
